module.exports = __webpack_public_path__ + "media/images/corp_login-b69247e0f3f47b593ebf9fa1225f46f9.jpg";